import { render, staticRenderFns } from "./QAList.vue?vue&type=template&id=a506f618&scoped=true"
import script from "./QAList.vue?vue&type=script&lang=js"
export * from "./QAList.vue?vue&type=script&lang=js"
import style0 from "./QAList.vue?vue&type=style&index=0&id=a506f618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a506f618",
  null
  
)

export default component.exports